import React from "react";

function formatTimestamp(timestamp) {
    if (!timestamp) {
        return "–";
    }
    const date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) {
        return "–";
    }
    return date.toLocaleString("de-DE");
}

function formatDuration(value) {
    if (value === null || value === undefined) {
        return "–";
    }
    return `${value} ms`;
}

export default function LogTable({
    logs,
    page,
    size,
    totalElements,
    onPageChange,
    onSelectCorrelation,
    selectedCorrelationId,
    isLoading,
}) {
    const totalPages = Math.max(1, Math.ceil(totalElements / size));

    function handlePrev() {
        if (page > 0) {
            onPageChange(page - 1);
        }
    }

    function handleNext() {
        if (page + 1 < totalPages) {
            onPageChange(page + 1);
        }
    }

    return (
        <div className="rounded-xl border border-slate-200 bg-white shadow-sm">
            <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3">
                <h3 className="text-sm font-semibold text-slate-700">Logeinträge</h3>
                <div className="flex items-center gap-2 text-xs text-slate-500">
                    <span>Seite {page + 1} / {totalPages}</span>
                    <button
                        type="button"
                        onClick={handlePrev}
                        disabled={page === 0 || isLoading}
                        className="rounded border border-slate-200 px-2 py-1 hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        ←
                    </button>
                    <button
                        type="button"
                        onClick={handleNext}
                        disabled={page + 1 >= totalPages || isLoading}
                        className="rounded border border-slate-200 px-2 py-1 hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        →
                    </button>
                </div>
            </div>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-slate-200">
                    <thead className="bg-slate-50">
                        <tr>
                            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-600">Zeit</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-600">Level</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-600">Event</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-600">Nachricht</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-600">Pfad</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-600">Status</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-600">Dauer</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-600">Correlation</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200 text-sm">
                        {logs.length === 0 ? (
                            <tr>
                                <td colSpan={8} className="px-3 py-6 text-center text-slate-500">
                                    {isLoading ? "Logs werden geladen ..." : "Keine Logeinträge gefunden."}
                                </td>
                            </tr>
                        ) : (
                            logs.map((entry) => {
                                const isSelected = entry.correlationId && entry.correlationId === selectedCorrelationId;
                                return (
                                    <tr
                                        key={entry.id}
                                        onClick={() => entry.correlationId && onSelectCorrelation(entry.correlationId)}
                                        className={`${isSelected ? "bg-blue-50" : "hover:bg-slate-50"} cursor-pointer`}
                                    >
                                        <td className="px-3 py-2 text-xs text-slate-600">{formatTimestamp(entry.createdAt)}</td>
                                        <td className="px-3 py-2 font-semibold text-slate-700">{entry.level || "–"}</td>
                                        <td className="px-3 py-2 text-slate-600">{entry.event || "–"}</td>
                                        <td className="px-3 py-2 text-slate-600">{entry.message || "–"}</td>
                                        <td className="px-3 py-2 text-slate-600">{entry.path || entry.entityName || "–"}</td>
                                        <td className="px-3 py-2 text-slate-600">{entry.status ?? "–"}</td>
                                        <td className="px-3 py-2 text-slate-600">{formatDuration(entry.durationMs)}</td>
                                        <td className="px-3 py-2 text-slate-600">{entry.correlationId || "–"}</td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
